var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"steps-header"},[(_vm.pageAttributes.aa_steps_header)?_c('span',[_vm._v("\n        "+_vm._s(_vm.getHeader)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }